import { Navigate } from 'react-router-dom';
import { PageTransition } from '../components/PageTransition';
import { LoadingBlock } from '../components/Spinner';
import { useStatsAccess } from '../hooks/useStatsAccess';
import { UnifiedStatistics } from '../components/Statistics/unified/UnifiedStatistics';

/**
 * Statistics — AI Statistics and CRM stats on one page. It replaced CRM stats and
 * Agency → Statistics, and is open to the same people Agency → Statistics was:
 * super admins, account owners, stats access, agency co-managers.
 */
export function StatisticsPage() {
  const access = useStatsAccess();
  if (access === false) return <Navigate to="/" replace />;
  return (
    <PageTransition>{access ? <UnifiedStatistics /> : <LoadingBlock />}</PageTransition>
  );
}
